// this was copied from here: https://stackoverflow.com/a/58989019/1958910
import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

@Directive({
    selector: '[appPositiveInteger]',
    providers: [{ provide: NG_VALIDATORS, useExisting: PositiveIntegerDirective, multi: true }],
    standalone: false
})
export class PositiveIntegerDirective implements Validator {

  validate(c: FormControl): { [key: string]: any } {

    if (c.value == null) {
      return null;
    }

    const v = + c.value;

    const stringNumber = '' + v;
    return (v < 0) || !Number.isInteger(v) || Number.isNaN(v) || stringNumber.length > 12 ? { positiveInteger: true } : null;
  }
}
